@if (employee) {
  <div class="flex gap-3">
    <gx-description-list
      (clickedItem)="selectFiltersForClickedItem($event)"
      [isClickable]="true"
      [items]="employee | employeeToItem" />
  </div>
  <section>
    <div class="flex items-baseline gap-3">
      <gx-section-title [title]="'team.competences' | translate" class="flex-1" data-testid="team-title" />
      @if (getSortedCompetences().length > 0) {
        <gx-dropdown
          (menuItemSelected)="competenceSortingChanged($event)"
          [createCaption]="captionForSorting"
          [defaultSelectedItems]="currentCompetenceSort"
          [icon]="downIcon"
          [isRightAligned]="true"
          [menuItems]="competenceSortItems"
          [multiSelect]="false"
          label="sorting.caption" />
      }
    </div>
    <ng-container [ngTemplateOutlet]="competences" />
  </section>
  <section>
    <gx-section-title [title]="'team.education' | translate" class="flex-1" />
    <ng-container [ngTemplateOutlet]="education" />
  </section>
  <section>
    <gx-section-title [title]="'team.groups' | translate" />
    <ul class="flex flex-col gap-2 lg:flex-row">
      @if (employee.boards.length <= 0) {
        <div class="italic">{{ 'employee.profile.no_groups' | translate }}</div>
      }
      @for (board of employee.boards; track board) {
        <li>
          <gx-pill (click)="boardClicked(board)" [caption]="board" />
        </li>
      }
    </ul>
  </section>
}

<ng-template #competences>
  @if (getSortedCompetences().length > 0) {
    <ol class="flex flex-col divide-y">
      @for (competence of getSortedCompetences(); track competence) {
        <li class="@lg:flex-row @lg:gap-3 flex flex-col items-start gap-1 py-3"
            [ngClass]="{ 'bg-yellow-100 border-l-4 border-yellow-500': isHighlighted(competence.name),
            'dark:bg-yellow-500/10 dark:border-yellow-400 dark:text-yellow-200': isHighlighted(competence.name)
             }"
        >
          <div class="flex-1">{{ competence.name }}</div>
          <div class="@lg:w-auto flex w-full justify-between gap-3">
            <div class="text-sm">{{ competence.duration }}</div>
            <gx-rating
              [rating]="competence.levelInt"
              activeRatingClass="__full-star"
              inactiveRatingClass="__empty-star"></gx-rating>
          </div>
        </li>
      }
    </ol>
  }

  @if (getSortedCompetences().length <= 0) {
    <div class="italic">
      {{ 'employee.profile.no_competences' | translate }}
    </div>
  }
</ng-template>

<ng-template #education>
  @if (getEducation().length > 0) {
    <ol class="flex flex-col divide-y">
      @for (education of getEducation(); track education) {
        <li class="@lg:flex-row @lg:gap-3 flex flex-col items-start gap-1 py-3">
          <div class="flex-1">{{ education }}</div>
        </li>
      }
    </ol>
  }

  @if (getEducation().length <= 0) {
    <div class="italic">{{ 'employee.profile.no_education' | translate }}</div>
  }
</ng-template>
